import React from "react";
import { Stack } from "@mui/material";
import {
    CloseIconButton,
    PreviewBlockImageContainer,
    SelectedContentButton,
} from "./PostForm.styles";
import { CloseIcon } from "@icons/CloseIcon";
import { POST_FORM_TABS } from "./PostFormModal.types";
import { LinkSolidIcon } from "@icons/LinkSolidIcon";
import { TEXT_ELLIPSIS } from "../../../Shared/styles";
import { LinkoutButtonText } from "../PostActions/PostActionButtons.styles";

export function SelectedLinkoutPreview({
    handleDeleteLinkout,
    linkoutUrl,
    setTabIndex,
}: {
    handleDeleteLinkout: (event: React.MouseEvent<HTMLButtonElement>) => void;
    linkoutUrl: string;
    setTabIndex: (value: POST_FORM_TABS) => void;
}) {
    return (
        <SelectedContentButton
            disableRipple
            onClick={(e) => {
                e.stopPropagation();
                setTabIndex(POST_FORM_TABS.LINKOUT);
            }}
        >
            <PreviewBlockImageContainer>
                <LinkSolidIcon
                    width={"16px"}
                    height={"16px"}
                    margin={"0 2px"}
                />
            </PreviewBlockImageContainer>
            <Stack
                sx={{
                    minWidth: 0,
                    ...TEXT_ELLIPSIS,
                }}
                flex="1"
                alignItems="flex-start"
            >
                <LinkoutButtonText>{linkoutUrl}</LinkoutButtonText>
            </Stack>
            <Stack
                onClick={(e) => {
                    e.stopPropagation();
                }}
            >
                <CloseIconButton onClick={handleDeleteLinkout}>
                    <CloseIcon />
                </CloseIconButton>
            </Stack>
        </SelectedContentButton>
    );
}
